export default __webpack_public_path__ + "static/media/ic-chevron-up.14d86928.svg";